import axios from "axios";

// CRA uses REACT_APP_* envs. For local dev, .env.development; for prod, Vercel env vars.
const baseURL =
  process.env.REACT_APP_API_BASE ||    // preferred
  process.env.REACT_APP_API_URL  ||    // legacy fallback
  "http://127.0.0.1:8000";             // local dev fallback

const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 20000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// A rejected token must land the user on the login screen.
//
// Without this, callers fall back to their empty state -- an expired session
// renders as "No users yet" or an empty packet list, which reads as data loss
// rather than "please sign in again". Anything that clears the token here also
// has to clear it everywhere, so we drop the whole auth bundle and do a hard
// redirect rather than a router push, to be sure no stale state survives.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("email");
      localStorage.removeItem("is_admin");
      // Avoid a redirect loop if the login request itself 401s on bad creds.
      const onLogin = window.location.pathname.startsWith("/login");
      const isLoginCall = (error.config?.url || "").includes("/login");
      if (!onLogin && !isLoginCall) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
